import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useAttraction } from "../lib/attraction";
import { Eye, Megaphone, LogOut } from "lucide-react";

// Shown on the attraction dashboard: super-admin impersonation bar + platform announcement.
export function PlatformBanners() {
  const { user, refresh } = useAuth();
  const { attraction } = useAttraction();
  const nav = useNavigate();
  const [announce, setAnnounce] = useState("");

  useEffect(() => {
    api.get("/platform/announcement").then((r) => setAnnounce(r.data.announcement || "")).catch(() => {});
  }, []);

  const impersonating = !!user?.impersonating_attraction_id;
  const exit = async () => {
    await api.post("/super/exit-impersonation");
    await refresh();
    nav("/super-admin/attractions", { replace: true });
  };

  return (
    <>
      {impersonating && (
        <div className="mb-4 flex items-center justify-between gap-3 rounded-lg bg-[#2a1212] border border-[#5b1919] px-4 py-2.5" data-testid="impersonation-banner">
          <div className="flex items-center gap-2 text-sm text-[#fca5a5]">
            <Eye size={15} /> Viewing as <span className="font-semibold text-white">{attraction?.name || "attraction"}</span> (super-admin)
          </div>
          <button onClick={exit} className="st-btn st-btn-ghost text-xs" data-testid="exit-impersonation"><LogOut size={13} /> Exit to platform admin</button>
        </div>
      )}
      {announce && (
        <div className="mb-4 flex items-start gap-2 rounded-lg bg-[#1a1205] border border-[#3a2a0a] px-4 py-2.5 text-sm text-[#e8c987]" data-testid="announcement-banner">
          <Megaphone size={15} className="mt-0.5 shrink-0" /> <span>{announce}</span>
        </div>
      )}
    </>
  );
}
